import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const MixpanelTokenField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	return <FullInfoField label="mixpanelTokenLabel" value={customerForFullInfo?.mixpanelToken} />;
};
